import React from 'react';
import styled from 'styled-components';
import { useTheme } from '@mui/material/styles';

import { CardContent as MuiCardContent, CardHeader, IconButton, Theme, Box } from '@mui/material';
import 'chart.js/auto';
import { spacing } from '@mui/system';
import '../../../vendor/roundedBarCharts';
import { Chart } from 'react-chartjs-2';

import { MoreVertical } from 'react-feather';
import { MinimalCard } from 'components/styled';

const CardContent = styled(MuiCardContent)`
  &:last-child {
    padding-bottom: ${(props) => props.theme.spacing(4)}px;
  }
`;

const ChartWrapper = styled.div`
  height: 237px;
  width: 100%;
`;

const BarChart = () => {
  const theme = useTheme();
  const firstDatasetColor = theme.palette.secondary.main;
  const secondDatasetColor =
    theme.palette.mode === 'dark' ? 'rgba(255, 255, 255, 0.5)' : 'rgba(0, 0, 0, 0.1)';

  const data = {
    labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
    datasets: [
      {
        label: 'Mobile',
        backgroundColor: firstDatasetColor,
        borderColor: firstDatasetColor,
        hoverBackgroundColor: firstDatasetColor,
        hoverBorderColor: firstDatasetColor,
        data: [54, 67, 41, 55, 62, 45, 55, 73, 60, 76, 48, 79],
        barPercentage: 0.4,
        categoryPercentage: 0.5,
      },
      {
        label: 'Desktop',
        backgroundColor: secondDatasetColor,
        borderColor: secondDatasetColor,
        hoverBackgroundColor: secondDatasetColor,
        hoverBorderColor: secondDatasetColor,
        data: [69, 66, 24, 48, 52, 51, 44, 53, 62, 79, 51, 68],
        barPercentage: 0.4,
        categoryPercentage: 0.5,
      },
    ],
  };

  return (
    <MinimalCard $hoverEffect={false} sx={{ mb: 3 }}>
      <CardHeader
        action={
          <IconButton aria-label="settings">
            <MoreVertical />
          </IconButton>
        }
        title="Mobile / Desktop"
      />
      <CardContent>
        <ChartWrapper>
          <Chart type="bar" data={data} />
        </ChartWrapper>
      </CardContent>
    </MinimalCard>
  );
};

export default BarChart;
